import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import UploadPage from "./pages/UploadPage";
import ResultPage from "./pages/ResultPage";
import Layout from "./Components/Layout";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./Components/Admin/AdminLogin";
import AdminDashboard from "./Components/Admin/AdminDashboard";
import PlansPage from "./pages/PlansPage";
import UserDashboard from "./pages/UserDashboard";
import ProtectedRoute from "./Outlines/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProfilePage from "./pages/ProfilePage";
import JobDetails from "./pages/JobDetails";
import ScrollToTop from "./Outlines/ScrollToTop";
import EmailVerification from "./Components/EmailVerification";
import LanguageLoader from "./Components/common/LanguageLoader";

const HomeRoute = () => {
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;

  return isAuthenticated ? (
    <Navigate to="/dashboard" />
  ) : (
    <Layout>
      <LoginPage />
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <LanguageLoader>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomeRoute />} />
            <Route
              path="/upload/:jobId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <UploadPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/result"
              element={
                <Layout>
                  <ResultPage />
                </Layout>
              }
            />
            <Route
              path="/login"
              element={
                <Layout>
                  <LoginPage />
                </Layout>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <Layout>
                  <ForgotPassword />
                </Layout>
              }
            />
            <Route
              path="/reset-password"
              element={
                <Layout>
                  <ResetPassword />
                </Layout>
              }
            />
            <Route
              path="/register"
              element={
                <Layout>
                  <RegisterPage />
                </Layout>
              }
            />
            <Route
              path="/admin"
              element={
                <Layout>
                  <AdminLogin />
                </Layout>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <Layout>
                  <AdminDashboard />
                </Layout>
              }
            />
            {/* <Route
            path="/Plan"
            element={
              <Layout>
                <PlansPage />
              </Layout>
            }
          /> */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs/:jobId"
              element={
                <ProtectedRoute>
                  <JobDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/email-verification"
              element={
                <EmailVerification />
              }
            />
          </Routes>
        </Router>
      </LanguageLoader>
    </AuthProvider>
  );
}

export default App;
